import React, { useRef, useState } from "react";
import SingleSelect from "@home/components/SingleSelect";
import { useIntl } from "umi";
import { LANGUAGE_CN, LANGUAGE_EN } from "@home/_config/config";
import { Segment } from "tea-component";
import { getLanguage } from "@home/utils/common";
import './index.scss';

const RevenueTrendSelector = (props: any) => {
  const { segmentList, selectorList, changeData, content, data } = props || {};
  const {selectedSegment: dataSelectedSegment} = data?.changeDataItem || {};
  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;;
  const [selectedList, setSelectedList] = useState(selectorList?.[0]?.value || "");
  const [selectedGame, setSelectedGame] = useState(selectorList?.[0] || {});
  const [selectedSegment, setSelectedSegment] = useState(dataSelectedSegment || "");
  const bindClassName = useRef(Date.now().toString(36));

  // Segment options处理
  const selectorOptions = selectorList?.map((option: { textEn: string; textCn: string; value: string; img: string; metrics: string[]; }) => ({
    text: getLanguage(isEn, option?.textEn, option?.textCn),
    value: option?.value,
    icon: option?.img,
    metrics: option?.metrics,
  })) || [];

  // Segment options处理
  const segmentOptions = segmentList?.map((option: { textEn: string; textCn: string; value: string; }) => ({
    text: getLanguage(isEn, option?.textEn, option?.textCn),
    value: option?.value
  }))?.filter((v: { value: any; }) => selectedGame?.metrics?.includes(v?.value)) || [];

  const handleSelectorChange = (val: string) => {
    if (val === selectedList) return;
    setSelectedList(val);
    const selectedGame = selectorList?.find((item: { value: string; }) => item?.value === val);
    setSelectedGame(selectedGame);
    if (!(selectedGame?.metrics?.includes(selectedSegment?.value))) {
      changeData?.("changeDataItem", {selectedGame, selectedSegment: segmentList?.[0]});
      setSelectedSegment(segmentList?.[0]);
      return;
    };
    changeData?.("changeDataItem", {selectedGame, selectedSegment});
  };

  const handleSegmentChange = (val: string) => {
    const matchedSegment = segmentList.find((item: { value: string; }) => item.value === val);
    setSelectedSegment(matchedSegment);
    changeData?.("changeDataItem", {selectedGame, selectedSegment: matchedSegment});
  };

  // Segment依赖于SingleSelect，根据SingleSelect的选中值来设置Segment的值
  // useEffect(() => {
  //   if (selectedGame?.metrics?.includes(selectedSegment?.value)) return;
  //   const defaultMetrics = segmentList?.[0] || "";
  //   setSelectedSegment(defaultMetrics);
  //   changeData?.("changeDataItem", {selectedGame, selectedSegment: defaultMetrics});
  // }, [changeData, segmentList, selectedGame, selectedSegment]);

  return (
    <div className="dbh-revenue-trend-panel">
      <div className="dbh-revenue-trend-panel-header">
        {/* 下拉选择框 */}
        <SingleSelect
          locale={isEn ? LANGUAGE_EN : LANGUAGE_CN}
          className={`dbh-revenue-trend-panel-selector panel-${bindClassName.current}`}
          popupContainer={ () => document.querySelector(`.panel-${bindClassName.current}`)}
          boxClassName="dbh-revenue-trend-panel-dropdown"
          options={selectorOptions}
          value={selectedList}
          onChange={handleSelectorChange}
          listWidth={"auto"}
          searchable={false}
          tooltip={""}
        />
        {/* Segment 组件 */}
        <Segment
          className={`dbh-revenue-trend-panel-segment ${selectedGame?.hideSegment ? "segment-hidden" : ""}`}
          value={selectedSegment?.value}
          onChange={handleSegmentChange}
          options={segmentOptions}
        />
      </div>
      <div className="dbh-revenue-trend-panel-content">
        {content}
      </div>
    </div>
  );
};

export default RevenueTrendSelector;
